export default __webpack_public_path__ + "d57818f73e9081057f2dd0e3712d925c.png";